import { css } from 'styled-components';

const color = {
  grey5: '#585858',
  grey4: '#939393',
  // grey-5-50: "#58585880",
  grey3: '#AFAFAF',
  grey2: '#DADADA',
  grey1: '#F9F9F9',
  greyLine: '#F0F0F0',
  boxShadow: '#00000029',
  white: '#FFF',
  white25: 'rgba(255,255,255,0.25)',
  white50: 'rgba(255,255,255,0.5)',
  pelorous: '#07A3C8',
  blueLagoon: '#0E6171',
  red: '#FF6A65',
  fadedBlack: '#000000B3',
  topBottomGradient: 'linear-gradient(to bottom, #3CB9C0, #07A3C8)',
};

const font = {
  thinWeight: '200',
  lightWeight: '300',
  mediumWeight: '400',
  boldWeight: '500',
  /* 11px */
  size11: '0.7rem',
  /* 13px */
  size13: '0.8rem',
  /* 15px */
  size15: '0.95rem',
  /* 19px */
  size19: '1.2rem',
  /* 21px */
  size21: '1.3rem',
  /* 23px */
  size23: '1.45rem',
};

const flex = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const center = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const topLeft = css`
  position: absolute;
  top: 0;
  left: 0;
`;

export { color, font, flex, center, topLeft };
